<template>
  <v-btn block class="text-center" @click="createInvoice()">
    <v-icon left>mdi-file-download-outline</v-icon>Download
  </v-btn>
</template>
<script>
import { mapGetters } from 'vuex';
import { jsPDF } from 'jspdf';
import storeConstants from '@/store/storeConstants';

export default {
  name: 'PrintInvoiceButton',
  components: {
  },
  props: {
    headerImageSrc: {
      type: String,
    },
  },
  data: () => ({
    defaultItemSpacing: 60,
    defaultXAxisPosition: 20,
    startYPosition: 65,
  }),
  computed: {
    ...mapGetters([storeConstants.INVOICE_BOOKING_DETAILS,
      storeConstants.SHORT_DATE_FORMAT]),
  },
  mounted() {
  },
  methods: {
    createInvoice() {
      // Default export is a4 paper, portrait, using millimeters for units
      // eslint-disable-next-line new-cap
      const doc = new jsPDF();

      const booking = this.INVOICE_BOOKING_DETAILS;

      doc.addImage(this.headerImageSrc, 'JPEG', 20, 20, 20, 6);

      this.renderHeader(doc, booking);

      const listItems = [];
      listItems.push({
        heading: 'Invoice Date',
        description: this.$moment(booking.invoiceDate).format(this.SHORT_DATE_FORMAT),
      });

      listItems.push({ heading: 'Name', description: booking.customerName });

      listItems.push({ heading: 'Booking number', description: booking.bookingNumber });

      if (booking.paymentType === 1 && !!booking.paymentReferenceNumber) {
        listItems.push({ heading: 'Payment Reference #', description: booking.paymentReferenceNumber });
      }

      //
      // Determine if this is a pickup, drop-off or return.
      //
      if (booking.direction === 1 || booking.direction === 3) {
        const pickupTimeRange = this.$moment(booking.pickupTime, [this.$moment.ISO_8601, 'HH:mm'])
          .add(30, 'minutes').format('HH:mm');

        listItems.push({
          heading: 'Pickup date/time',
          description: `${this.$moment(booking.pickupDate).format(this.SHORT_DATE_FORMAT)} `
            + `${booking.pickupTime} - ${pickupTimeRange}`,
        });
        listItems.push({ heading: 'Pickup address', description: booking.pickupAddress });
        listItems.push({ heading: 'Departing flight', description: booking.departingFlight });
      }
      if (booking.direction === 2 || booking.direction === 3) {
        listItems.push({ heading: 'Drop-off date', description: this.$moment(booking.dropOffDate).format(this.SHORT_DATE_FORMAT) });
        listItems.push({ heading: 'Arriving flight', description: booking.arrivingFlight });
      }

      listItems.push({ heading: 'Fare', description: `${this.$options.filters.toCurrency(booking.fare)}` });

      this.renderListItems(doc, listItems);
      this.renderFooter(doc);

      doc.save(`ASN-Invoice-${booking.bookingNumber}.pdf`);
    },
    renderListItems(doc, listItems) {
      const xPos = this.defaultXAxisPosition + this.defaultItemSpacing;
      let yPos = this.startYPosition;

      listItems.forEach((item, index) => {
        yPos = this.startYPosition + (index * 7);
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.text(item.heading, this.defaultXAxisPosition, yPos);
        doc.setFont('helvetica', 'normal');
        doc.text(`${item.description}`, xPos, yPos);
      });

      doc.setFontSize(8);
      doc.text('NOTE: fare/price includes GST', 20, (yPos + 15));
    },
    renderHeader(doc, booking) {
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(20);
      doc.setTextColor(0, 0, 0);
      doc.text(`Tax Invoice #T${booking.bookingNumber}`, 20, 40);

      doc.setFontSize(14);
      doc.setFont('helvetica', 'normal');
      doc.text('Airport Shuttle North Pty Ltd', 20, 50);
      doc.setFontSize(8);
      doc.text('ABN 47 119 366 442', 20, 55);
    },
    renderFooter(doc) {
      doc.setFontSize(8);
      doc.text('Airport Shuttle North Pty Ltd - ABN 47 119 366 442', this.defaultXAxisPosition, 285);
      doc.text('Enquiries +61 2 99977767', 150, 285);
    },
  },
};
</script>
